// @ts-nocheck
export const selectServiceMessages = state => state.message.serviceMessages;
export const selectPlatforms = state => state.message.platforms;
